import '../styles/LandingPage/Ctaband.css';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CtaBand() {
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelector('.cta-content').style.animationPlayState = 'running';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      sectionRef.current.querySelector('.cta-content').style.animationPlayState = 'paused';
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta-band" id="contact" ref={sectionRef}>
      {/* Morphing aurora blobs */}
      <div className="cta-aurora">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
        <div className="blob blob-4" />
      </div>

      {/* Rising particles */}
      <div className="cta-particles">
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
      </div>

      {/* Pulsing light rays */}
      <div className="cta-rays" />

      {/* Subtle noise texture */}
      <div className="cta-noise" />

      <div className="cta-content">
        <div className="s-label">Get in Touch</div>
        <h2>Let's Work Together.</h2>
        <p>Research partnership, technical peer review, or advisory engagement — Actyra delivers with precision.</p>

        <div className="cta-actions">
          <button onClick={() => navigate('/contact')} className="btn-teal">Contact Actyra</button>
          <a href="#research" className="btn-ghost-light">View Research</a>
        </div>

        <div className="cta-sub">
          Or reach us at <a href="mailto:info@actyra.co.ke">info@actyra.co.ke</a>
        </div>
      </div>
    </section>
  );
}
